<template>
	<div class="titulo--post">
		Listagem de posts
	</div>
</template>
<script>
	export default {
		name: "FrameList",
		data() {
    	return {
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/blocks/FrameList.vue